import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';

import CONFIG from '../../../config';

import { VpTextLimit } from '..';
import { StyledBox } from './styles';
import crakIds from '../../../constants/crak';
import { StarRating } from '../StarRating';

export const VpPromptAnswer = ({ prompt, mediaLabels, campaignId }) => {
  if (prompt?.mediaId || prompt?.attachmentId) {
    return (
      <Chip label={`${mediaLabels[prompt?.mediaId || prompt?.attachmentId]}`} variant="colorTag" />
    );
  } else if (prompt?.isDeleted) {
    return <Chip label="Content Deleted" sx={{ margin: '0' }} />;
  } else if (prompt.isTermsAndConditionsSignature) {
    return <StyledBox component="img" src={prompt?.fileUrl} />;
  } else if (prompt?.campaignElement?.type === crakIds.RATING) {
    return <StarRating value={prompt?.answer} />;
  } else if (prompt?.question === "Signature Photo" && prompt?.answer?.slice(-3) === 'png') {
    const legacySignaturePath = `${CONFIG.AWS.S3bucket}/campaign/signature_photo/original/${campaignId}/${prompt?.answer}`;
    return <StyledBox component="img" src={legacySignaturePath} />;
  }

  return <VpTextLimit value={prompt?.answer} limit={250} />;
};

VpPromptAnswer.propTypes = {
  prompt: PropTypes.object.isRequired,
  mediaLabels: PropTypes.object.isRequired
};

export default VpPromptAnswer;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpPromptAnswer/VpPromptAnswer.jsx